/**
 * SEO Verification Tags Component
 * Injects meta verification tags from environment variables
 */

import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SEOVerificationTags = () => {
  const googleVerification = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION;
  const bingVerification = process.env.REACT_APP_BING_SITE_VERIFICATION;

  useEffect(() => {
    if (!googleVerification) return;
    const existingTags = document.querySelectorAll('meta[name="google-site-verification"]');
    if (existingTags.length) return;
    const metaTag = document.createElement('meta');
    metaTag.setAttribute('name', 'google-site-verification');
    metaTag.setAttribute('content', googleVerification);
    document.head.appendChild(metaTag);
    return () => {
      metaTag.remove();
    };
  }, [googleVerification]);

  const hasPrerenderedBingVerification =
    typeof document !== 'undefined' &&
    document.querySelector('meta[name="msvalidate.01"]');
  if (!bingVerification || hasPrerenderedBingVerification) return null;

  return (
    <Helmet>
      {bingVerification && <meta name="msvalidate.01" content={bingVerification} />}
    </Helmet>
  );
};

export default SEOVerificationTags;
